import { Injectable, OnDestroy } from "@angular/core";
import { HttpHeaders, HttpClient } from "@angular/common/http";

import { Observable, Subject } from "rxjs";

import { AccountByType } from "../models/account.model";
import { GetHeadlineDetailPayload } from "../models/dashboard.model";
import { feedbackModel, LabelLayoutModel } from "../models/settings.model";

@Injectable({
  providedIn: "root",
})
export class SettingsService implements OnDestroy{
  private url = "api/settings";

  private headers = new HttpHeaders({ "Content-Type": "application/json" });
  options = { headers: this.headers };
  private destroy$ = new Subject<void>();
  saveSettingSignalRIds:any[]=[];

  constructor(private http: HttpClient) { }

  public GetAllAccounts() {
    return this.http.get(`/${this.url}/getallaccounts`, this.options);
  }

  public GetAccountsByType(): Observable<AccountByType[]> {
    return this.http.get<AccountByType[]>(
      `/${this.url}/GetAccountsByType`,
      this.options
    );
  }

  GetAccountsByRegion(amazonMarketRegionId){
    return this.http.get(`/${this.url}/GetAccountsByRegion?AmazonMarketRegionId=${amazonMarketRegionId}`, this.options);
  }

  public GetAllVendors() {
    return this.http.get(`/${this.url}/getallvendors`, this.options);
  }

  public GetAllWarehouses() {
    return this.http.get(`/${this.url}/getallwarehouses`, this.options);
  }

  public GetWarehouse(id: any) {
    return this.http.get(`/${this.url}/getwarehouse/${id}`, this.options);
  }

  public DeleteAccount(acccount: any) {
    return this.http.delete(
      `/${this.url}/deleteaccount/${acccount}`,
      this.options
    );
  }

  public DeleteWh(id: any) {
    return this.http.delete(`/${this.url}/deletewh/${id}`, this.options);
  }


  public DeleteWh2(WarehouseId: any) {
    return this.http.post(
      `/api/logistics/DeleteWareHouse`,
      {WarehouseId},
      this.options
    );
  }

  public UpdateWh(request: any) {
    const data = JSON.stringify(request);
    return this.http.put(`/${this.url}/updatewh`, data, this.options);
  }

  public ToggleWhsIsFba(id: string, enable: boolean) {
    return this.http.put(
      `/${this.url}/togglewhsisfba?id=${id}&enable=${enable}`,
      this.options
    );
  }

  public GetAllPrinters() {
    return this.http.get(`/${this.url}/getallprinters`, this.options);
  }

  public GetSelectedPrinter() {
    return this.http.get(`/${this.url}/GetSelectedPrinterByUser`, this.options);
  }

  public GetIncludeFnSkuOnPrint() {
    return this.http.get(`/${this.url}/GetIncludeFnSkuOnPrintByUser`, this.options);
  }

  public GetRemoveShipFromPrint() {
    return this.http.get(`/${this.url}/GetRemoveShipFromPrintByUser`, this.options);
  }

  public GetShowAmazonPrepDetail(): Observable<boolean> {
    return this.http.get<boolean>(
      `/${this.url}/GetShowAmazonPrepDetailByUser`,
      this.options
    );
  }

  public GetDefaultPrintTwoDLabel(): Observable<boolean> {
    return this.http.get<boolean>(
      `/${this.url}/GetDefaultPrintTwoDLabelByUser`,
      this.options
    );
  }

  public SavePrinter(
    printer: string,
    width: number,
    height: number,
    printerType: number,
    isThermal: boolean,
    stickerSetting?:any
  ) {
    const data = JSON.stringify({
      printer,
      width,
      height,
      printerType,
      isThermal,
      stickerSetting
    });
    return this.http.post(`/${this.url}/saveprinterByUser`, data, this.options);
  }

  public IncludeFnSkuOnPrint(isOn: boolean) {
    const payload = {
      isOn :isOn
    }
    return this.http.post(
      `/${this.url}/IncludeFnSkuOnPrintByUser`,
      payload,
      this.options
    );
  }

  public RemoveShipFromPrint(isOn: boolean) {
    const payload = {
      isOn :isOn
    }
    return this.http.post(
      `/${this.url}/RemoveShipFromPrintByUser`,
      payload,
      this.options
    );
  }

  public ShowAmazonPrepDetail(payload) {
    return this.http.post(
      `/${this.url}/ShowAmazonPrepDetailByUser`,payload,
      this.options
    );
  }

  public DefaultPrintTwoDLabel(isOn: boolean) {
    const payload = {
      isOn :isOn
    }
    return this.http.post(
      `/${this.url}/DefaultPrintTwoDLabelByUser`,
      payload,
      this.options
    );
  }

  public GetPrintFnskuBoxLable(): Observable<boolean> {
    return this.http.get<boolean>(
      `/${this.url}/GetPrintFnskuBoxLableByUser`,
      this.options
    );
  }

  public DefaultPrintFnskuBoxLable(isOn: boolean) {
    const payload = {
      isOn :isOn
    }
    return this.http.post(
      `/${this.url}/DefaultPrintFnskuBoxLableByUser`,
      payload,
      this.options
    );
  }
   
  GetLastUsedWarehouse(accountName: any) {
    return this.http.get(`/${this.url}/GetLastUsedWarehouse/${accountName}`, {
      headers: this.headers,
      responseType: "text",
    });
  }

  GetVelocitySettings() {
    return this.http.get(`/${this.url}/GetVelocitySettings`, this.options);
  }

  GetPurchaseDaysSetting() {
    return this.http.get(`/${this.url}/GetPurchaseDaysSetting`, this.options);
  }

  GetSettings(keys: string[]) {
    return this.http.post(`/${this.url}/GetSettings`, {keys}, this.options);
  }

  SaveSettings(properties: any[]) {
    return this.http.post(`/${this.url}/SaveSettings`, {settings: properties}, this.options);
  }

  public SaveVelocitySettings(body: any) {
    return this.http.post(
      `/${this.url}/SaveVelocitySettings`,
      body,
      this.options
    );
  }

  SaveReplenishDaysSetting(body: any) {
    return this.http.post(
      `/${this.url}/SaveReplenishDaysSetting`,
      body,
      this.options
    );
  }

  SavePurchaseDaysSetting(body: any) {
    return this.http.post(
      `/${this.url}/SavePurchaseDaysSetting`,
      body,
      this.options
    );
  }

  GetHeadlines(IsNewOnNineyard) {
    return this.http.get(`/${this.url}/GetHeadlines?IsNewOnNineyard=${IsNewOnNineyard}`, this.options);
  }

  GetHeadlinesGroupDate(IsNewOnNineyard) {
    return this.http.get(`/${this.url}/GetHeadlinesGroupDate?IsNewOnNineyard=${IsNewOnNineyard}`, this.options);
  }

  GetHeadlineDetail(payload:GetHeadlineDetailPayload) {
    return this.http.get(`/${this.url}/GetHeadlineDetail?IsNewOnNineyard=${payload.isNewOnNineyard}&FilterDate=${payload.date}
    &StartRow=${payload.startRow}&EndRow=${payload.endRow}`,
      this.options);
  }

  GetLabelLayoutSetting(){
    return this.http.get(`/${this.url}/GetLabelLayoutSetting`, this.options);
  }

  SaveLabelLayoutSetting(payload:LabelLayoutModel){
    return this.http.post(`/${this.url}/SaveLabelLayoutSetting`,
      payload,
      this.options
    );
  }
  SaveFeedback(payload:feedbackModel){
    return this.http.post(`/${this.url}/SaveFeedback`,
      payload,
      this.options
    );
  }

  GetPrintVerticleSetting(){
    return this.http.get(`/${this.url}/GetPrintVerticleSettingByUser`, this.options);
  }

  public SavePrintVerticleSetting(isOn: boolean) {
    return this.http.post(
      `/${this.url}/PrintVerticleSettingByUser`,{isOn},
      this.options
    );
  }

   GetPrintSkuNoteBoxLable(): Observable<boolean> {
    return this.http.get<boolean>(
      `/${this.url}/GetPrintSkuNoteBoxLableByUser`,this.options);
  }

   PrintSkuNoteBoxLable(payload) {
    return this.http.post(
      `/${this.url}/PrintSkuNoteBoxLableByUser`,payload,this.options);
  }

  SaveSettingsSignalR(properties){
    return this.http.post(`/${this.url}/SaveSettingsSignalR`,
    {settings: properties},
      this.options
  );
  }

GetBoxExpDateSettingByUser(): Observable<boolean> {
    return this.http.get<boolean>(
      `/${this.url}/GetBoxExpDateSettingByUser`,
      this.options
    );
  }

  BoxExpDateSettingByUser(payload) {
    return this.http.post(
      `/${this.url}/BoxExpDateSettingByUser`,payload,this.options);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }  

  GetShipStationStores(){
    return this.http.get(`/${this.url}/GetShipStationStores`, this.options);
  }

  SaveShipStationStores(payload){
    return this.http.post(`/${this.url}/SaveShipStationStores`, payload,this.options);
  }

  DeleteShipStationStores(payload){
    return this.http.post(`/${this.url}/DeleteShipStationStores`,payload,this.options);
  }

  setLogisticsScanSetting(isOn){
    return this.http.post(`/${this.url}/SetLogisticsScanSetting`,{isOn},this.options);
  }

  GetLogisticsScanSetting(){
    return this.http.get(`/${this.url}/GetLogisticsScanSetting`,this.options);
  }
  

  SaveIgnoreDaysSettings(body: any) {
    return this.http.post(
      `/${this.url}/SaveIgnoreDaysSettings`,
      body,
      this.options
    );
  }

  ExportWarehouse() {
    return this.http.get(
      `/${this.url}/WarehouseExport`,
       {
        headers: this.headers,
        observe: "response",
        responseType: "blob",
      }
    );
  }
}
